import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    id = '',
    content = {},
}, options = { showError: true }) => {
    const [ res, error, status ] = await POST(URLS.kpi.kpiStorage.saveContent, {
        id,
        content,
    }, options);
    if (error) return { error, status };
    return res || { };
};
